import { useCallback, useEffect, useState } from "react";
import { ChevronRight, Undo2 } from "lucide-react";
import api, { inr, fmtDate, fmtErr } from "../../lib/api";
import { toast } from "sonner";

const FLOW = ["RETURN_REQUESTED", "PICKUP_SCHEDULED", "IN_TRANSIT", "RECEIVED", "REFUNDED"];

export default function AdminReturns() {
  const [returns, setReturns] = useState(null);

  const load = useCallback(() => api.get("/admin/returns").then(({ data }) => setReturns(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const advance = async (r) => {
    try {
      const { data } = await api.post(`/returns/${r.return_id}/advance`);
      toast.success(`Return → ${data.status.replace(/_/g, " ")}`);
      load();
    } catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <div data-testid="admin-returns-page">
      <h1 className="font-display text-2xl font-bold tracking-tight text-shipany-navy">Returns</h1>
      <p className="text-sm text-slate-500">All reverse shipments and refunds.</p>
      <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid="admin-returns-table">
        <table className="w-full min-w-[880px] text-sm">
          <thead>
            <tr className="bg-shipany-navy text-left text-xs uppercase tracking-wider text-white">
              <th className="px-5 py-3.5">Reverse AWB</th><th className="px-4 py-3.5">Original AWB</th><th className="px-4 py-3.5">Customer</th>
              <th className="px-4 py-3.5">Reason</th><th className="px-4 py-3.5">Refund</th><th className="px-4 py-3.5">Status</th><th className="px-4 py-3.5">Date</th><th className="px-4 py-3.5"></th>
            </tr>
          </thead>
          <tbody>
            {(returns || []).map((r) => (
              <tr key={r.return_id} className="border-t border-slate-100" data-testid={`admin-return-${r.reverse_awb}`}>
                <td className="mono px-5 py-3 font-semibold text-shipany-blue"><Undo2 className="mr-1 inline h-3.5 w-3.5" />{r.reverse_awb}</td>
                <td className="mono px-4 py-3 text-xs text-slate-500">{r.awb}</td>
                <td className="px-4 py-3 text-xs text-slate-500">{r.customer_email}</td>
                <td className="px-4 py-3 text-xs">{r.reason}</td>
                <td className="mono px-4 py-3 font-semibold">{inr(r.refund_amount)}</td>
                <td className="px-4 py-3"><span className="rounded-full bg-shipany-blue/10 px-2.5 py-0.5 text-[11px] font-bold text-shipany-blue">{r.status.replace(/_/g, " ")}</span></td>
                <td className="px-4 py-3 text-xs text-slate-500">{fmtDate(r.created_at)}</td>
                <td className="px-4 py-3 text-right">
                  {r.status !== "REFUNDED" && r.status !== "RECEIVED" && (
                    <button onClick={() => advance(r)} data-testid={`admin-return-advance-${r.return_id}`}
                      className="flex items-center gap-1 rounded-lg bg-shipany-navy px-3.5 py-1.5 text-xs font-bold text-white hover:bg-shipany-blue">Advance <ChevronRight className="h-3 w-3" /></button>
                  )}
                </td>
              </tr>
            ))}
            {returns && returns.length === 0 && <tr><td colSpan={8} className="px-6 py-10 text-center text-slate-400">No returns yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
